<template>
  <div class="member-page-wrap">
    <template v-if="!pageLoading">
      <div class="data-tab">
        <div class="tab-item" v-for="(i, idx) in tab" :class="{ 'active': i.location === activeTab }"
          :key="`${i.location}-${idx}`" @click="changeTab(i.location)">{{ i.name }}</div>
      </div>
      <div class="data-content" v-if="currentMember && currentMember.home">
        <div class="content-title">
          <div class="home">
            <img :src="currentMember.home.team_logo || ''" @error="onLolTeamLogoError" alt="" />
            <span>{{ currentMember.home.team_name }}</span>
          </div>
          <div class="limit">
            <el-popover v-model="limitShow" placement="bottom" width="130" popper-class="limit-wrap-popper"
              trigger="click">
              <div class="limit-wrap">
                <div class="limit-item" v-for="(item, idx) in limits" :class="{ 'active': item.limit === limit }"
                  :key="`${idx}-${item.limit}`" @click="changeLimit(item.limit)">{{ item.label }}</div>
              </div>
              <div class="limit-button" slot="reference">
                <span>{{ activeLimit }}</span>
                <img src="../../../assets/images/gaming/down-icon.png" alt="">
              </div>
            </el-popover>
          </div>
          <div class="away">
            <span>{{ currentMember.away.team_name }}</span>
            <img :src="currentMember.away.team_logo || ''" @error="onLolTeamLogoError" alt="" />
          </div>
        </div>
        <div class="content">
          <div class="player-wrap">
            <div class="home">
              <div class="name">
                <div class="avatar">
                  <div class="img">
                    <img :src="currentMember.home.player_avatar || ''" @error="onLolTeamLogoError" alt="">
                  </div>
                </div>
                <span>{{ currentMember.home.player_name }}</span>
              </div>
              <div class="player-kda">
                <p>
                  <span>{{ currentMember.home.kda || 0 }}</span>
                  <span>{{ (currentMember.home.kill_count || 0) | numFixOne }}/{{ (currentMember.home.death_count || 0) |
      numFixOne }}/{{ (currentMember.home.assist_count || 0) | numFixOne }}</span>
                </p>
                <div class="line">
                  <div class="kill" :style="{ width: homePlayerKda.k + '%' }"></div>
                  <div class="death" :style="{ width: homePlayerKda.d + '%' }"></div>
                  <div class="assist" :style="{ width: homePlayerKda.a + '%' }"></div>
                </div>
              </div>
            </div>
            <div>K/D/A</div>
            <div class="away">
              <div class="player-kda">
                <p>
                  <span>{{ (currentMember.away.kill_count || 0) | numFixOne }}/{{ (currentMember.away.death_count || 0) |
      numFixOne }}/{{ (currentMember.away.assist_count || 0) | numFixOne }}</span>
                  <span>{{ currentMember.away.kda || 0 }}</span>
                </p>
                <div class="line">
                  <div class="assist" :style="{ width: awayPlayerKda.a + '%' }"></div>
                  <div class="death" :style="{ width: awayPlayerKda.d + '%' }"></div>
                  <div class="kill" :style="{ width: awayPlayerKda.k + '%' }"></div>
                </div>
              </div>
              <div class="name">
                <div class="avatar">
                  <div class="img">
                    <img :src="currentMember.away.player_avatar || ''" @error="onLolTeamLogoError" alt="">
                  </div>
                </div>
                <span>{{ currentMember.away.player_name }}</span>
              </div>
            </div>
          </div>
          <div class="player-data">
            <div class="home">
              <div class="success">
                <div class="process">
                  <el-progress type="circle" :width="88" :stroke-width="15" :color="'#D40C2D'"
                    :percentage="homeSuccessRate"></el-progress>
                </div>
                <div class="success-count">
                  <div>
                    <img src="../../../assets/images/gaming/player-success-icon.png" alt="">
                    <span>{{ currentMember.home.success_count || 0 }}</span>
                  </div>
                  <div>
                    <img src="../../../assets/images/gaming/player-fail-icon.png" alt="">
                    <span>{{ currentMember.home.fail_count || 0 }}</span>
                  </div>
                </div>
              </div>
              <div class="hero-history">
                <p>常用英雄</p>
                <div class="hero-list">
                  <div v-for="(hero, idx) in currentMember.home.common_heros" :key="`${idx}`">
                    <img :src="hero.hero_avatar" alt="">
                    <p>
                      <span>{{ hero.success_count }}</span>-<span>{{ hero.fail_count }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="player-total-data">
              <div class="data-rate">
                <div class="title">
                  <div class="home" :class="{ 'active': homeMemberClass.isHomeOfferedWin }">{{
      (currentMember.home.offered_rate || 0) | numFixOne }}%</div>
                  <div>参战率</div>
                  <div class="away" :class="{ 'active': awayMemberClass.isAwayOfferedWin }">{{
      (currentMember.away.offered_rate || 0) | numFixOne }}%</div>
                </div>
                <div class="line">
                  <div class="home">
                    <div class="active" :style="{ width: (currentMember.home.offered_rate || 0) + '%' }"></div>
                  </div>
                  <div class="away">
                    <div class="active" :style="{ width: (currentMember.away.offered_rate || 0) + '%' }"></div>
                  </div>
                </div>
              </div>
              <div class="data-rate">
                <div class="title">
                  <div class="home" :class="{ 'active': homeMemberClass.isHomeHitWin }">{{
      (currentMember.home.last_hit_minute || 0) | numFixOne }}</div>
                  <div>分均补刀</div>
                  <div class="away" :class="{ 'active': awayMemberClass.isAwayHitWin }">{{
      (currentMember.away.last_hit_minute || 0) | numFixOne }}</div>
                </div>
                <div class="line">
                  <div class="home">
                    <div class="active" :style="{ width: (homeHitRate || 0) + '%' }"></div>
                  </div>
                  <div class="away">
                    <div class="active" :style="{ width: (awayHitRate || 0) + '%' }"></div>
                  </div>
                </div>
              </div>
              <div class="data-rate">
                <div class="title">
                  <div class="home" :class="{ 'active': homeMemberClass.isHomeDamageWin }">{{
      (currentMember.home.damage_minute || 0) | numFixOne }}</div>
                  <div>分均输出</div>
                  <div class="away" :class="{ 'active': awayMemberClass.isAwayDamageWin }">{{
      (currentMember.away.damage_minute || 0) | numFixOne }}</div>
                </div>
                <div class="line">
                  <div class="home">
                    <div class="active" :style="{ width: (homeDamageRate || 0) + '%' }"></div>
                  </div>
                  <div class="away">
                    <div class="active" :style="{ width: (awayDamageRate || 0) + '%' }"></div>
                  </div>
                </div>
              </div>
              <div class="data-rate">
                <div class="title">
                  <div class="home" :class="{ 'active': homeMemberClass.isHomeMoneyWin }">{{
      (currentMember.home.money_minute || 0) | numFixOne }}</div>
                  <div>分均经济</div>
                  <div class="away" :class="{ 'active': awayMemberClass.isAwayMoneyWin }">{{
      (currentMember.away.money_minute || 0) | numFixOne }}</div>
                </div>
                <div class="line">
                  <div class="home">
                    <div class="active" :style="{ width: (homeMoneyRate || 0) + '%' }"></div>
                  </div>
                  <div class="away">
                    <div class="active" :style="{ width: (awayMoneyRate || 0) + '%' }"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="away">
              <div class="success">
                <div class="process">
                  <el-progress type="circle" :width="88" :stroke-width="15" :color="'#3069C1'"
                    :percentage="awaySuccessRate"></el-progress>
                </div>
                <div class="success-count">
                  <div>
                    <img src="../../../assets/images/gaming/player-success-icon.png" alt="">
                    <span>{{ currentMember.away.success_count || 0 }}</span>
                  </div>
                  <div>
                    <img src="../../../assets/images/gaming/player-fail-icon.png" alt="">
                    <span>{{ currentMember.away.fail_count || 0 }}</span>
                  </div>
                </div>
              </div>
              <div class="hero-history">
                <p>常用英雄</p>
                <div class="hero-list">
                  <div v-for="(hero, idx) in currentMember.away.common_heros" :key="`${idx}`">
                    <img :src="hero.hero_avatar" alt="">
                    <p>
                      <span>{{ hero.success_count }}</span>-<span>{{ hero.fail_count }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="page-loading" v-if="pageLoading">
      <div class="img-wrap">
        <img src="//static.fly2a.com/static/image/f-jiazai-min.png" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MemberData',
  data() {
    return {
      limitShow: false,
      tab: [
        {
          name: 'adc',
          location: 1
        },
        {
          name: '中单',
          location: 2
        },
        {
          name: '上单',
          location: 3
        },
        {
          name: '打野',
          location: 4
        },
        {
          name: '辅助',
          location: 5
        }
      ],
      activeTab: 1,
      limit: -1,
      limits: [
        {
          limit: -1,
          label: '全部'
        },
        {
          limit: 1,
          label: '近10场'
        },
        {
          limit: 2,
          label: '近20场'
        },
        {
          limit: 3,
          label: '近30场'
        },
        {
          limit: 4,
          label: '近40场'
        },
        {
          limit: 5,
          label: '近50场'
        }
      ],
      adc: {},
      top: {},
      jug: {},
      mid: {},
      sup: {},
      pageLoading: false
    }
  },
  filters: {
    numFixOne(num) {
      return (Math.floor(num * 10) / 10).toFixed(1)
    }
  },
  computed: {
    activeLimit() {
      const idx = this.limits.findIndex(limit => limit.limit === this.limit)
      return this.limits[idx].label
    },
    currentMember() {
      let member = this.adc
      switch (this.activeTab) {
        case 1:
          member = this.adc
          break;
        case 2:
          member = this.mid
          break;
        case 3:
          member = this.top
          break;
        case 4:
          member = this.jug
          break;
        case 5:
          member = this.sup
          break;
        default:
          break;
      }
      return member
    },
    homePlayerKda() {
      let data = {
        k: 0,
        d: 0,
        a: 0
      }
      if (this.currentMember && this.currentMember.home && this.currentMember.home.player_id) {
        let total = Number(this.currentMember.home.kill_count) + Number(this.currentMember.home.assist_count) + Number(this.currentMember.home.death_count)
        data.k = Math.floor(Number(this.currentMember.home.kill_count) / total * 100)
        data.d = Math.floor(Number(this.currentMember.home.death_count) / total * 100)
        data.a = Math.floor(Number(this.currentMember.home.assist_count) / total * 100)
      }
      return data
    },
    awayPlayerKda() {
      let data = {
        k: 0,
        d: 0,
        a: 0
      }
      if (this.currentMember && this.currentMember.away && this.currentMember.away.player_id) {
        let total = Number(this.currentMember.away.kill_count) + Number(this.currentMember.away.assist_count) + Number(this.currentMember.away.death_count)
        data.k = Math.floor(Number(this.currentMember.away.kill_count) / total * 100)
        data.d = Math.floor(Number(this.currentMember.away.death_count) / total * 100)
        data.a = Math.floor(Number(this.currentMember.away.assist_count) / total * 100)
      }
      return data
    },
    homeSuccessRate() {
      let rate = this.currentMember.home.success_count / (this.currentMember.home.success_count + this.currentMember.home.fail_count)
      return Math.floor(rate * 100) || 0
    },
    awaySuccessRate() {
      let rate = this.currentMember.away.success_count / (this.currentMember.away.success_count + this.currentMember.away.fail_count)
      return Math.floor(rate * 100) || 0
    },
    homeHitRate() {
      let rate = Number(this.currentMember.home.last_hit_minute || 0) / (Number(this.currentMember.home.last_hit_minute || 0) + Number(this.currentMember.away.last_hit_minute || 0))
      return Math.floor(rate * 10000) / 100 || 0
    },
    awayHitRate() {
      let rate = Number(this.currentMember.away.last_hit_minute || 0) / (Number(this.currentMember.home.last_hit_minute || 0) + Number(this.currentMember.away.last_hit_minute || 0))
      return Math.floor(rate * 10000) / 100 || 0
    },
    homeDamageRate() {
      let rate = Number(this.currentMember.home.damage_minute || 0) / (Number(this.currentMember.home.damage_minute || 0) + Number(this.currentMember.away.damage_minute || 0))
      return Math.floor(rate * 10000) / 100 || 0
    },
    awayDamageRate() {
      let rate = Number(this.currentMember.away.damage_minute || 0) / (Number(this.currentMember.home.damage_minute || 0) + Number(this.currentMember.away.damage_minute || 0))
      return Math.floor(rate * 10000) / 100 || 0
    },
    homeMoneyRate() {
      let rate = Number(this.currentMember.home.money_minute || 0) / (Number(this.currentMember.home.money_minute || 0) + Number(this.currentMember.away.money_minute || 0))
      return Math.floor(rate * 10000) / 100 || 0
    },
    awayMoneyRate() {
      let rate = Number(this.currentMember.away.money_minute || 0) / (Number(this.currentMember.home.money_minute || 0) + Number(this.currentMember.away.money_minute || 0))
      return Math.floor(rate * 10000) / 100 || 0
    },
    homeMemberClass() {
      const isHomeOfferedWin = (Math.floor((this.currentMember.home.offered_rate || 0) * 10) / 10).toFixed(1) > (Math.floor((this.currentMember.away.offered_rate || 0) * 10) / 10).toFixed(1)
      const isHomeHitWin = (Math.floor((this.currentMember.home.last_hit_minute || 0) * 10) / 10).toFixed(1) > (Math.floor((this.currentMember.away.last_hit_minute || 0) * 10) / 10).toFixed(1)
      const isHomeDamageWin = (Math.floor((this.currentMember.home.damage_minute || 0) * 10) / 10).toFixed(1) > (Math.floor((this.currentMember.away.damage_minute || 0) * 10) / 10).toFixed(1)
      const isHomeMoneyWin = (Math.floor((this.currentMember.home.money_minute || 0) * 10) / 10).toFixed(1) > (Math.floor((this.currentMember.away.money_minute || 0) * 10) / 10).toFixed(1)
      return {
        isHomeOfferedWin,
        isHomeHitWin,
        isHomeDamageWin,
        isHomeMoneyWin
      }
    },
    awayMemberClass() {
      const isAwayOfferedWin = (Math.floor((this.currentMember.home.offered_rate || 0) * 10) / 10).toFixed(1) < (Math.floor((this.currentMember.away.offered_rate || 0) * 10) / 10).toFixed(1)
      const isAwayHitWin = (Math.floor((this.currentMember.home.last_hit_minute || 0) * 10) / 10).toFixed(1) < (Math.floor((this.currentMember.away.last_hit_minute || 0) * 10) / 10).toFixed(1)
      const isAwayDamageWin = (Math.floor((this.currentMember.home.damage_minute || 0) * 10) / 10).toFixed(1) < (Math.floor((this.currentMember.away.damage_minute || 0) * 10) / 10).toFixed(1)
      const isAwayMoneyWin = (Math.floor((this.currentMember.home.money_minute || 0) * 10) / 10).toFixed(1) < (Math.floor((this.currentMember.away.money_minute || 0) * 10) / 10).toFixed(1)
      return {
        isAwayOfferedWin,
        isAwayHitWin,
        isAwayDamageWin,
        isAwayMoneyWin
      }
    }
  },
  methods: {
    changeTab(tab) {
      let member = this.adc
      switch (tab) {
        case 1:
          member = this.adc
          break;
        case 2:
          member = this.mid
          break;
        case 3:
          member = this.top
          break;
        case 4:
          member = this.jug
          break;
        case 5:
          member = this.sup
          break;
        default:
          break;
      }
      if (!member.home) {
        this.getMember(tab)
      } else {
        this.activeTab = tab
      }
    },
    getMember(location) {
      let query = "";
      if (this.$route.query && this.$route.query.id) {
        query = `?tournament_id=${this.$route.query.id}&location=${location || this.activeTab}&limit=${this.limit}`;
      }
      axios
        .get(COMMOND.NEW_BASE_URL + "v2/lol_member_analysis" + query).then(res => {
          if (res.data.code === 200 && res.data.data) {
            this.pageLoading = false
            switch (location || this.activeTab) {
              case 1:
                this.adc = res.data.data
                break;
              case 2:
                this.mid = res.data.data
                break;
              case 3:
                this.top = res.data.data
                break;
              case 4:
                this.jug = res.data.data
                break;
              case 5:
                this.sup = res.data.data
                break;
              default:
                break;
            }
            if (location) {
              this.activeTab = location
            }
          }
        })
    },
    changeLimit(limit) {
      this.limit = limit
      this.limitShow = false
      this.getMember()
    }
  },
  mounted() {
    this.pageLoading = true
    this.getMember()
  }
}
</script>

<style lang="less" scoped>
.member-page-wrap {
  .data-tab {
    display: flex;
    height: 66px;
    background: #fff;
    border-radius: 5px;

    .tab-item {
      flex: 1;
      text-align: center;
      line-height: 66px;
      color: #13161B;
      font-size: 22px;
      cursor: pointer;

      &.active {
        color: #fff;
        background: #E65668;
        border-radius: 5px;
      }
    }
  }

  .data-content {
    .content-title {
      padding: 18px 56px;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      box-shadow: 0px 3px 7px 0px rgba(205, 57, 67, 0.2);

      .home,
      .away {
        display: flex;
        align-items: center;
        gap: 10px;

        img {
          width: 38px;
          height: 38px;
        }
      }

      .limit-button {
        cursor: pointer;
        width: 120px;
        height: 35px;
        line-height: 35px;
        background: #FFFFFF;
        border: 1px solid #000000;
        border-radius: 5px;
        text-align: center;
        font-size: 14px;
        display: flex;
        justify-content: center;
        gap: 10px;
        align-items: center;

        img {
          width: 12px;
        }
      }
    }

    .content {
      box-shadow: 0px 3px 7px 0px rgba(205, 57, 67, 0.2);

      .player-wrap {
        display: flex;
        gap: 36px;
        align-items: center;
        padding: 18px 56px;
        box-shadow: inset 0px -1px 0px 0px rgba(224, 224, 224, 0.25);

        .home,
        .away {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .name {
            text-align: center;

            .avatar {
              height: 63px;
              width: 63px;
              margin-bottom: 8px;
              border-radius: 50%;
              overflow: hidden;
              position: relative;
              padding: 1px;

              &::after {
                content: ' ';
                position: absolute;
                background-color: #fff;
                top: 1px;
                left: 1px;
                right: 1px;
                bottom: 1px;
                background-clip: padding-box, border-box;
                background-origin: padding-box, border-box;
                border-radius: 50%;
                overflow: hidden;
              }

              &::before {
                content: ' ';
                position: absolute;
                background-image: linear-gradient(90deg, rgba(245, 94, 29, 1), rgba(212, 12, 45, 1)), linear-gradient(rgba(245, 94, 29, 1), rgba(212, 12, 45, 1));
                top: -1px;
                left: -1px;
                right: -1px;
                bottom: -1px;
                background-clip: padding-box, border-box;
                background-origin: padding-box, border-box;
              }

              .img {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                border-radius: 50%;
                overflow: hidden;

                img {
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                  margin: 0 auto;
                  z-index: 1;
                }
              }
            }

            span {
              font-size: 14px;
            }
          }

          .player-kda {
            p {
              span {
                margin-right: 15px;
                font-size: 14px;

                &:last-child {
                  color: #777;
                }
              }
            }

            .line {
              display: flex;
              height: 10px;
              margin-top: 10px;
              border-radius: 10px;
              width: 238px;
              background: #EDE4E4;
              overflow: hidden;
              gap: 2px;

              .kill {
                background: #DE243B;
              }

              .death {
                background: #1A1A1A;
              }

              .assist {
                background: #C58C40;
              }
            }
          }
        }

        .away {
          .name {
            .avatar {
              &::before {
                background-image: linear-gradient(90deg, rgba(120, 239, 249, 1), rgba(48, 105, 193, 1)), linear-gradient(rgba(120, 239, 249, 1), rgba(48, 105, 193, 1));
              }
            }
          }

          .player-kda {
            p {
              text-align: right;

              span {
                margin-right: 0;
                margin-left: 15px;

                &:first-child {
                  color: #777;
                }

                &:last-child {
                  color: #000;
                }
              }
            }
          }
        }
      }

      .player-data {
        padding: 65px 56px;
        display: flex;
        justify-content: center;
        gap: 56px;

        >.home,
        >.away {
          .success {
            display: flex;
            align-items: center;
            flex-direction: column;

            .process {
              margin-bottom: 10px;

              /deep/ .el-progress-circle {
                svg {
                  transform: rotateY(180deg);
                }
              }
            }

            .success-count {
              display: flex;
              gap: 10px;

              div {
                flex: 1;
                display: flex;
                align-items: center;
                gap: 4px;

                img {
                  widows: 23px;
                  height: 23px;
                }

                span {
                  font-size: 14px;
                }
              }
            }
          }

          .hero-history {
            margin-top: 26px;
            align-items: center;
            display: flex;
            flex-direction: column;

            >p {
              font-size: 14px;
              text-align: center;
              margin-bottom: 15px;
            }

            .hero-list {
              display: flex;
              gap: 10px;

              div {
                img {
                  display: block;
                  width: 43px;
                  height: 43px;
                  border-radius: 50%;
                  margin-bottom: 10px;
                }

                span {
                  &:first-child {
                    color: #D7142B
                  }

                  &:last-child {
                    color: #98CB4A
                  }
                }
              }
            }
          }
        }

        .player-total-data {
          width: 420px;
          padding-top: 30px;

          .data-rate {
            margin-bottom: 20px;

            .title {
              display: flex;
              justify-content: space-between;
              margin-bottom: 10px;

              .away {
                text-align: right;
              }

              .home {
                &.active {
                  color: #D40C2D;
                }
              }

              .away {
                &.active {
                  color: #3069C1;
                }
              }
            }

            .line {
              display: flex;
              gap: 10px;

              .home,
              .away {
                background: #F3F3F3;
                border-radius: 10px;
                height: 10px;
                width: 204px;
                position: relative;

                .active {
                  position: absolute;
                  top: 0;
                  height: 10px;
                }
              }

              .home {
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;

                .active {
                  right: 0;
                  background: linear-gradient(90deg, #F55E1D 0%, #D40C2D 100%);
                  border-top-left-radius: 10px;
                  border-bottom-left-radius: 10px;
                }
              }

              .away {
                border-top-right-radius: 10px;
                border-bottom-right-radius: 10px;

                .active {
                  left: 0;
                  background: linear-gradient(90deg, #78EFF9 0%, #3069C1 100%);
                  border-top-right-radius: 10px;
                  border-bottom-right-radius: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.page-loading {
  min-height: 50vh;
  position: relative;

  .img-wrap {
    position: absolute;
    left: 50%;
    top: 200px;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 150px;
    height: 150px;
    background: rgba(0, 0, 0, .1);
    border-radius: 50%;

    img {
      margin: 55px 0 0 20px;
      animation: jiazai 4s ease-in-out infinite forwards;
    }
  }
}

.empty-page {
  img {
    display: block;
    width: 50%;
    margin: 80px auto;
  }

  p {
    text-align: center;
    font-size: 16px;
    position: relative;
    top: -150px;
  }
}
</style>

<style lang="less">
.limit-wrap-popper {
  padding: 1px;
  border-radius: 10px;
}

.limit-wrap {
  border-radius: 10px;
  overflow: hidden;

  .limit-item {
    height: 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;

    &.active {
      background: #D40C2D;
      color: #fff;
    }
  }

}
</style>
